export const IMAGE = 1;
export const VIDEO = 2;
export const DOCUMENT = 3;
export const AUDIO = 4;
export const VIDEO_ATTACHMENT = 5;
